module.exports = __webpack_public_path__ + "static/img/apply-be-site.1c397664.png";